<template>
  <div class="page-wrapper">
    <div class="tiles d-flex flex-row pa-2">
      <div class="tile-wrapper" v-for="(tile, index) in tiles" :key="index">
        <header-tile :icon="tile.icon" :count="tile.count" :name="tile.name" />
      </div>
    </div>
    <div class="actions d-flex flex-row align-center pr-2 pl-2">
      <ul class="actions-wrapper">
        <li class="action-items table-search ma-2">
          <v-text-field
            v-model="searchString"
            class="searchbar"
            hide-details
            dense
            clearable
            solo
            label="Search by Project"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </li>
        <li class="action-items">
          <div class="text-center">
            <v-menu
              v-model="filterMenu"
              :close-on-content-click="false"
              max-width="300px"
              min-width="300px"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn color="white" v-on="on" class="ma-3">
                  <v-icon>mdi-filter</v-icon>filter
                </v-btn>
              </template>
              <v-card class="pb-4">
                <v-list>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Status</div>
                      <v-select
                        v-model="filters.status"
                        placeholder="Select Status"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        :items="statusList"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Project</div>
                      <v-select
                        v-model="filters.project"
                        placeholder="Select Project"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        :items="projectNamesList"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Date</div>
                      <v-dialog
                        ref="dialog"
                        v-model="filterDateModal"
                        :return-value.sync="filters.date"
                        persistent="false"
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filters.date"
                            placeholder="Pick a Date"
                            readonly
                            outlined
                            background-color="white"
                            dense
                            filled
                            hide-details
                            v-on="on"
                            append-icon="mdi-calendar-month"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="filters.date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="filterDateModal = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog.save(filters.date)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#0e07b5" outlined @click="closeFiltersMenu"
                    >Cancel</v-btn
                  >
                  <v-btn color="#0e07b5" outlined @click="resetAppliedFilters"
                    >Reset</v-btn
                  >
                  <v-btn
                    color="#0e07b5"
                    class="mr-4 white--text"
                    @click="applyFilters"
                    >Apply</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
        </li>
        <v-spacer></v-spacer>
        <li class="action-items">
          <v-btn
            depressed
            dark
            large
            color="#0e07b5"
            class="ma-3"
            @click="$refs.dataTable.exportToExcel()"
          >
            <v-icon>mdi-file-excel</v-icon>Export to Excel
          </v-btn>
        </li>
      </ul>
    </div>
    <div class="table">
      <data-table
        ref="dataTable"
        :dense="true"
        :multiSelect="true"
        :fixedHeader="true"
        :headers="headers"
        :content="filteredDataArray"
        :isCheckable="true"
        :allowExportToExcel="true"
        :searchString="searchString"
        @update="updateItem"
        @selectedRow="rowSelected"
        @display="displaySheetImages"
      ></data-table>
    </div>
    <v-dialog v-model="imageDialog" max-width="600px">
      <v-card class="pa-4">
        <div
          id="mdiv"
          @click="
            () => {
              imageDialog = false;
            }
          "
        >
          <div class="mdiv">
            <div class="md"></div>
          </div>
        </div>
        <v-card-title class="justify-center">
          <span class="headline indigo--text">Worksheet Images</span>
        </v-card-title>
        <v-card-text class="text-center">
          <v-container fluid v-if="displayImages.length > 0">
            <v-row>
              <v-col
                v-for="(image, n) in displayImages"
                :key="n"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card
                  flat
                  tile
                  class="d-flex"
                  @click="displayFullImage(image)"
                >
                  <v-img
                    :src="image.src"
                    :lazy-src="image.src"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <template v-else>No Data Found</template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined @click="imageDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="updateDialog" max-width="600px">
      <v-card class="pa-4">
        <div
          id="mdiv"
          @click="
            () => {
              updateDialog = false;
            }
          "
        >
          <div class="mdiv">
            <div class="md"></div>
          </div>
        </div>
        <v-card-title class="justify-center">
          <span class="headline indigo--text">Update Worksheet Status</span>
        </v-card-title>
        <v-card-text>
          <div class="subtitle-2 mb-1">Timesheet Status</div>
          <v-select
            background-color="white"
            v-model="timesheetStatus"
            :items="statusList"
            placeholder="Select"
            :rules="[(v) => !!v || 'Value is required']"
            outlined
            dense
            required
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined @click="updateDialog = false"
            >Close</v-btn
          >
          <v-btn color="#0e07b5" class="white--text" @click="updateSheetStatus"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="weekdayDialog" max-width="700px">
      <v-card class="pa-4">
        <div
          id="mdiv"
          @click="
            () => {
              weekdayDialog = false;
            }
          "
        >
          <div class="mdiv">
            <div class="md"></div>
          </div>
        </div>
        <v-card-title class="justify-center">
          <span class="headline indigo--text">WeekDay List</span>
        </v-card-title>
        <v-card-text>
          <data-table
            :headers="dayListHeaders"
            :content="weekdayList"
            :index="true"
          ></data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined @click="weekdayDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="imageDisplayDialog" max-height="75vh" max-width="75vw">
      <v-card>
        <div
          id="mdiv"
          @click="
            () => {
              imageDisplayDialog = false;
            }
          "
        >
          <div class="mdiv">
            <div class="md"></div>
          </div>
        </div>
        <v-card-text class="displayImage">
          <v-img
            :src="imageDisplayDialogImage.src"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          >
            <v-card-title v-text="imageDisplayDialogImage.name"></v-card-title>
          </v-img>
        </v-card-text>
        <v-card-actions>
          <v-card-title v-text="imageDisplayDialogImage.name"></v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            outlined
            @click="imageDisplayDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import HeaderTile from "@/components/HeaderTile.vue";
import DataTable from "@/components/DataTable.vue";
import fcmServerkey from "../fcm_serverkey";

import firebase from "../firebase";

export default {
  name: "Timesheet",
  components: {
    HeaderTile,
    DataTable
  },
  data() {
    return {
      searchString: "",
      filterMenu: false,
      filterDateModal: false,
      filters: {
        date: "",
        project: "",
        status: ""
      },
      filteredDataArray: [],
      updateTableData: true,
      imageDisplayDialog: false,
      imageDisplayDialogImage: "",
      imageDialog: false,
      updateDialog: false,
      weekdayDialog: false,
      displayImages: [],
      weekdayList: [],
      statusList: ["Pending", "Accepted", "Rejected"],
      projectNamesList: [],
      timesheetStatus: "",
      projectsRef: null,
      rawData: new Object(),
      timesheets: [],
      worksheet: null,
      waitingFor: 0,
      tiles: [],
      headers: [
        {
          name: "employee",
          label: "Employee Name",
          type: "text"
        },
        {
          name: "customer",
          label: "Customer",
          type: "text"
        },
        {
          name: "project",
          label: "Project Name",
          type: "text"
        },
        {
          name: "startDate",
          label: "Start Date",
          type: "date"
        },
        {
          name: "endDate",
          label: "End Date",
          type: "date"
        },
        {
          name: "status",
          label: "Status",
          type: "status"
        },
        {
          name: "totalHours",
          label: "Total Hours",
          type: "text"
        },
        {
          label: "Action",
          type: "action",
          actions: [
            {
              label: "Update",
              value: "update"
            },
            {
              label: "Images",
              value: "images"
            }
          ]
        }
      ],
      dayListHeaders: [
        {
          name: "created",
          label: "Date",
          type: "date"
        },
        {
          name: "workHours",
          label: "Work Hours",
          type: "text"
        },
        {
          name: "extraHours",
          label: "Extra Hours",
          type: "text"
        },
        {
          name: "pto",
          label: "Time Off",
          type: "text"
        },
        {
          name: "netHours",
          label: "Net Hours",
          type: "text"
        }
      ]
    };
  },
  created() {
    let self = this;
    this.projectsRef = firebase.firestore().collection("projects");
    this.projectsRef.onSnapshot((querySnapshot) => {
      self.rawData = [];
      querySnapshot.docs.forEach((doc) => {
        doc.ref.collection("Employees").onSnapshot((empQuerySnapshot) => {
          empQuerySnapshot.docs.forEach((empDoc) => {
            self.waitingFor++;
            let timeSheetData = empDoc.data();
            empDoc.ref
              .collection("workSheet")
              .onSnapshot((workQuerySnapShot) => {
                if (self.waitingFor == 0) self.populateTimesheets();
                workQuerySnapShot.forEach((workDoc) => {
                  let workDocData = workDoc.data();
                  let rawId =
                    workDocData.projectId +
                    workDocData.userId +
                    workDocData.startAt;
                  self.rawData[rawId] = {
                    timeSheetData: timeSheetData,
                    workSheetData: workDocData
                  };
                });
                self.waitingFor--;
              });
          });
        });
      });
    });
  },
  computed: {
    // worksheet: ()=>{
    //   return this.currWorksheet;
    // }
  },
  watch: {
    waitingFor() {
      if (this.waitingFor == 0) {
        this.populateTimesheets();
      }
    }
  },
  methods: {
    populateTimesheets() {
      let accepted = 0;
      let rejected = 0;
      let pending = 0;
      this.timesheets = [];
      this.projectNamesList = [];
      for (const key in this.rawData) {
        let data = this.rawData[key];
        let sheet = {
          employee: data.timeSheetData.employeeName || "",
          customer: data.timeSheetData.customer || "",
          project: data.timeSheetData.projectName || "",
          startDate: data.workSheetData.startAt || null,
          endDate: data.workSheetData.endAt || null,
          status: data.workSheetData.status || "",
          totalHours: Number(data.workSheetData.totalHours).toFixed(2) || 0,
          images: data.workSheetData.timeSheetImages || [],
          data: data
        };
        this.timesheets.push(sheet);

        if (data.timeSheetData.projectName)
          this.projectNamesList.push(data.timeSheetData.projectName);

        switch (data.workSheetData.status) {
          case "Pending":
            pending++;
            break;
          case "Accepted":
            accepted++;
            break;
          case "Rejected":
            rejected++;
            break;
          default:
            break;
        }
      }
      this.tiles = [
        {
          icon: "mdi-star-outline",
          count: pending,
          name: "Pending Requests"
        },
        {
          icon: "mdi-star-outline",
          count: accepted,
          name: "Accepted Requests"
        },
        {
          icon: "mdi-star-outline",
          count: rejected,
          name: "Rejected Requests"
        }
      ];

      this.filteredDataArray = this.timesheets;
    },
    displaySheetImages(images) {
      this.displayImages = [];
      if (images && images.length > 0) {
        images.forEach((image) => {
          this.displayImages.push({
            src: image.imageUrl,
            name: image.imageName
          });
        });
      }
      this.updateDialog = false;
      this.imageDialog = true;
    },

    updateItem(item) {
      // debugger;
      this.worksheet = item.data.workSheetData;
      if ("status" in this.worksheet) {
        this.timesheetStatus = this.worksheet.status;
      }
      this.imageDialog = false;
      this.updateDialog = true;
    },

    updateSheetStatus() {
      // debugger;
      this.updateDialog = false;
      this.worksheet.status = this.timesheetStatus;
      this.$refs.dataTable.refresh(this.timesheetStatus);
      // this.updateTableData = !this.updateTableData;
      // this.$forceUpdate();
      // let self = this;

      var worksheet = this.worksheet;
      this.worksheet = null;
      this.projectsRef
        .doc(worksheet.projectId.toString())
        .get()
        .then((doc) => {
          doc.ref
            .collection("Employees")
            .doc(worksheet.userId.toString())
            .get()
            .then((doc2) => {
              doc2.ref
                .collection("workSheet")
                .doc(worksheet.startAt.toString())
                .update(worksheet)
                .then(() => {});
            });
        });
    },

    async sendTimesheetNotification(
      tokens,
      title,
      subtitle,
      imageUrl,
      userId,
      projectId
    ) {
      // Simple POST request with a JSON body using fetch
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "key=" + fcmServerkey
        },
        body: JSON.stringify({
          notification: {
            title: title,
            body: subtitle
          },
          data: {
            imageUrl: imageUrl,
            click_action: "FLUTTER_NOTIFICATION_CLICK"
          },
          registration_ids: tokens
        })
      };
      // debugger;
      await fetch("https://fcm.googleapis.com/fcm/send", requestOptions)
        .then((response) => {
          // debugger;
          return response;
        })
        .then(() => {
          firebase
            .firestore()
            .collection("notifications")
            .add({
              userId: userId,
              projectId: projectId,
              // projectName: project.projectName,
              imageUrl: imageUrl,
              createdAt: new Date().valueOf(),
              read: false,
              title: title,
              // clientName: project.client,
              // customerName: project.customer,
              description: subtitle
            });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    rowSelected(item) {
      this.weekdayList = [];
      if ("weekDayList" in item.data.workSheetData) {
        let weekDayList = item.data.workSheetData.weekDayList;
        weekDayList.forEach((day) => {
          let payload = {
            created: day.dayTime,
            workHours: day.workHour,
            extraHours: day.extraHour,
            pto: day.pto,
            netHours: day.workHour + day.extraHour + day.pto
          };
          this.weekdayList.push(payload);
        });
        this.weekdayDialog = true;
      }
    },

    displayFullImage(image) {
      this.imageDisplayDialogImage = image;
      this.imageDisplayDialog = true;
    },
    resetAllFilters() {
      for (const key in this.filters) {
        this.filters[key] = "";
      }
    },
    closeFiltersMenu() {
      this.filterDateModal = false;
      this.filterMenu = false;
    },
    applyFilters() {
      let self = this;
      this.filteredDataArray = [];
      this.filterDateModal = false;
      this.filterMenu = false;
      this.filteredDataArray = this.timesheets.filter((sheet) => {
        let found = false;
        for (const key in self.filters) {
          const val = self.filters[key];
          if (val) {
            if (key == "date") {
              let date1 = new Date(sheet.startDate);
              let date3 = new Date(sheet.endDate);
              let date2 = new Date(val);
              if (
                date1.getFullYear() == date2.getFullYear() &&
                date1.getMonth() == date2.getMonth() &&
                date1.getDate() == date2.getDate()
              )
                found = true;
              else if (
                date3.getFullYear() == date2.getFullYear() &&
                date3.getMonth() == date2.getMonth() &&
                date3.getDate() == date2.getDate()
              )
                found = true;
              else {
                found = false;
                break;
              }
            } else if (sheet[key] == val) found = true;
            else {
              found = false;
              break;
            }
          }
        }
        return found;
      });
    },
    resetAppliedFilters() {
      this.filterDateModal = false;
      this.filterMenu = false;
      this.resetAllFilters();
      this.filteredDataArray = this.timesheets;
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 1vh 1vw;
}
.tiles {
  padding: 10px 0px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  height: auto;
}

.tile-wrapper {
  width: 33%;
}

.actions-wrapper {
  width: 100%;
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px;
  padding: 0px;
  flex-wrap: wrap;
}

.table-search {
  width: 100%;
  min-width: 200px;
  max-width: 600px;
}

.v-input--selection-controls {
  margin-top: 0px;
}

.displayImage {
  width: 98%;
  height: 70vh;
  overflow: auto;
  padding: 20px;
  margin: 20px;
  box-sizing: border-box;
}

#mdiv {
  width: 25px;
  height: 25px;
  float: right;
  /* background-color: red; */
  /* border: 1px solid black; */
}

.mdiv {
  height: 25px;
  width: 2px;
  margin-left: 12px;
  background-color: grey;
  transform: rotate(45deg);
  z-index: 1;
}

.md {
  height: 25px;
  width: 2px;
  background-color: grey;
  transform: rotate(90deg);
  z-index: 2;
}
</style>
